export enum EventNames {
    FavouriteAppListModified = 'FavouriteAppListModified',
    MainApplicationLoaded = 'MainApplicationLoaded',
    StartApplicationTour = 'StartApplicationTour',
    OpenFeedbackModal = 'OpenFeedbackModal',
    UserOpenedSideDraw = 'UserOpenedSideDraw',
    HideSideDraw = 'HideSideDraw',
    OpenSideDraw = 'OpenSideDraw',
    MakeSureGlobalSearchIsVisible = 'MakeSureGlobalSearchIsVisible',
    MakeSureHelpIsVisible = 'MakeSureHelpIsVisible',
}

interface IEventMap {
    [EventNames.FavouriteAppListModified]: unknown;
    [EventNames.MainApplicationLoaded]: unknown;
    [EventNames.StartApplicationTour]: unknown;
    [EventNames.OpenFeedbackModal]: unknown;
    [EventNames.UserOpenedSideDraw]: unknown;
    [EventNames.HideSideDraw]: unknown;
    [EventNames.OpenSideDraw]: unknown;
    [EventNames.MakeSureGlobalSearchIsVisible]: unknown;
    [EventNames.MakeSureHelpIsVisible]: unknown;
}

type EventHandler<T = unknown> = (data?: T) => void;

export class EventBus {
    public static subscribe<K extends string>(eventName: K, eventHandler: EventHandler<any>): void {
        EventBus.eventHandlers[eventName] = EventBus.eventHandlers[eventName] || [];
        EventBus.eventHandlers[eventName].push(eventHandler as EventHandler);
    }

    public static unsubscribe<K extends string>(eventName: K, eventHandler: EventHandler<any>): void {
        if (EventBus.eventHandlers[eventName]) {
            EventBus.eventHandlers[eventName] = EventBus.eventHandlers[eventName].filter(
                (existingHandler) => existingHandler !== (eventHandler as EventHandler),
            );
        }
    }

    public static emit<K extends string>(eventName: K, data?: IEventMap[K & keyof IEventMap] | unknown): void {
        if (EventBus.eventHandlers[eventName]) {
            EventBus.eventHandlers[eventName].forEach((eventHandler) => eventHandler(data));
        }
    }

    private static eventHandlers: { [eventName: string]: EventHandler[] } = {};
}
